<div class="alert-modal">
  <button type="button" class="close-btn" (click)="onClose('no')" aria-label="Close">
    <i class="bi bi-x-lg"></i>
  </button>

  <div class="alert-body">
    <div class="alert-ico">
      <i class="bi bi-question-circle-fill"></i>
    </div>
    <h3 class="alert-title">Confirm</h3>
    <p class="alert-message">{{ data.message }}</p>
  </div>

  <div class="alert-actions">
    <button type="button" class="btn btn-secondary" (click)="onClose('no')">
      {{ data.noAction }}
    </button>
    <button type="button" class="btn btn-primary" (click)="onClose('yes')">
      {{ data.yesAction }}
    </button>
  </div>
</div>
